import React from 'react'
import { useTheme } from '../context/ThemeContext';
import CloseButton from './CloseButton';

interface ConfirmDialogProps {
  open: boolean
  title?: string
  description?: string
  confirmText?: string
  cancelText?: string
  onClose: (result: boolean) => void
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  title = 'Confirm',
  description = 'Are you sure?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  onClose,
}) => {
  const { theme } = useTheme();
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center"
      style={{ backgroundColor: theme.components.modal.overlay }}
    >
      <div
        className="rounded-xl shadow-lg w-full max-w-sm relative overflow-hidden"
        style={{
          background: theme.components?.card?.background || '#FFFFFF',
          border: `1px solid ${theme.components?.card?.border || '#E8E6E1'}`,
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
        }}
      >
        {/* Header */}
        <div
          className="px-5 py-4 relative"
          style={{
            background: theme.components?.card?.background || '#FFFFFF',
            borderBottom: `1px solid ${theme.components?.card?.border || '#E8E6E1'}`,
          }}
        >
          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold" style={{ color: theme.text }}>
              {title}
            </h2>
            <CloseButton onClick={() => onClose(false)} size="sm" />
          </div>
        </div>

        {/* Content */}
        <div className="p-5" style={{ background: theme.components?.card?.background || '#FFFFFF' }}>
          {description && <p className="mb-5" style={{ color: theme.gray?.[600] || '#475569' }}>{description}</p>}
        </div>

        {/* Actions */}
        <div
          className="px-5 py-3 flex justify-end gap-2"
          style={{
            background: theme.background,
            borderTop: `1px solid ${theme.components?.card?.border || '#E8E6E1'}`
          }}
        >
          <button
            onClick={() => onClose(false)}
            className="px-4 py-2 rounded-md text-sm font-medium transition-colors"
            style={{
              color: theme.gray?.[500] || '#6b7280',
              backgroundColor: 'transparent',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = theme.components?.card?.hover || '#f3f4f6';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
            }}
          >
            {cancelText}
          </button>
          <button
            onClick={() => onClose(true)}
            className="px-4 py-2 rounded-md text-sm font-semibold transition-colors"
            style={{
              backgroundColor: theme.primary,
              color: theme.button?.primary?.text || 'white',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = theme.button?.primary?.hover || theme.primary;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = theme.primary;
            }}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDialog;